// extracted by mini-css-extract-plugin
module.exports = {"header":"gridSection_header__lgzC-"};